export const UFS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

// UFs que desativaram o webservice de inutilização de NF-e/NFC-e (Ajustes SINIEF 40/2026 e 38/2026)
export const UFS_INUTILIZACAO_DESATIVADA = [
  "AC",
  "BA",
  "SP"
];

export const OPERACOES_NFE = [
  { valor: "INUTILIZACAO", label: "Inutilização de número de notas" },
  { valor: "STATUS", label: "Consultar status do serviço" },
  { valor: "CONTRIBUINTE", label: "Consultar cadastro de contribuinte" },
];

export const OPERACOES_NFCE = [
  { valor: "INUTILIZACAO", label: "Inutilização de número de notas" },
  { valor: "STATUS", label: "Consultar status do serviço" },
  { valor: "SITUACAO", label: "Consultar situação" },
];

export const TITULO = {
  NFE: "Nota Fiscal (NF-e)",
  NFCE: "Nota Fiscal do Consumidor (NFC-e)",
};

export const OPERACOES_DESTRUTIVAS = ["CANCELAMENTO", "INUTILIZACAO", "CCE"];
